import { render, staticRenderFns } from "./AchievementBadge.vue?vue&type=template&id=d4134124&"
import script from "./AchievementBadge.vue?vue&type=script&lang=js&"
export * from "./AchievementBadge.vue?vue&type=script&lang=js&"
import style0 from "./AchievementBadge.vue?vue&type=style&index=0&id=d4134124&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports